export default {
  MuiFormGroup: {
    row: { '& .MuiFormControlLabel-root': { marginRight: 24 } },
  },
};
